/* eslint-disable max-len */
import verticals from 'i18n/messages/segments/verticals.nl';
import guides from 'i18n/messages/segments/guides.nl';

const nl = {
  meta: {
    home: {
      title: 'GastroBuddy — één app voor de vloer + AI-assistent (gratis maand)',
      description:
        'Start je gratis maand. Checklists, kas, recepten, tijdregistratie, webdashboard en een AI-assistent voor eigenaren. Klaar in een paar minuten.',
    },
    onboard: {
      title: 'Aanmelden — GastroBuddy | gratis proefperiode',
      description:
        'Maak je GastroBuddy-account aan en start je proefperiode. Beheer locaties, schakel modules in en nodig je team uit.',
    },
    terms: {
      title: 'Algemene voorwaarden — GastroBuddy',
      description: 'Algemene voorwaarden voor het gebruik van GastroBuddy en horeca-tools.',
    },
    privacy: {
      title: 'Privacybeleid — GastroBuddy',
      description:
        'Hoe GastroBuddy persoonsgegevens verwerkt voor website, dashboard en mobiele apps.',
    },
    cookies: {
      title: 'Cookies — GastroBuddy',
      description:
        'Informatie over cookies en vergelijkbare technieken op gastrobuddy.nl en gerelateerde sites.',
    },
    contact: {
      title: 'Contact — GastroBuddy',
      description: 'Neem contact op met GastroBuddy voor support, sales en privacy.',
    },
    compare: {
      title: 'GastroBuddy vs papier & generieke tools',
      description:
        'Bekijk hoe GastroBuddy zich verhoudt tot ringbanden, spreadsheets en generieke taken-apps voor de horecavloer.',
    },
    checklist: {
      title: 'Gratis open/sluit-checklist voor de horeca — GastroBuddy',
      description:
        'Een praktische open- en sluitchecklist voor horecateams. Gebruik hem zo, en draai hem daarna in GastroBuddy met je team.',
    },
    pricing: {
      title: 'Prijzen — GastroBuddy plannen & modules',
      description:
        'Kies een plan op teamgrootte en optionele modules per locatie. Betaal op het web; de app ontgrendelt met je account.',
    },
    forIndex: {
      title: 'GastroBuddy voor restaurants, hotels, bars en meer',
      description:
        'Zie hoe GastroBuddy past bij restaurants, hotels, bars, cafés en catering. Start daarna je gratis maand.',
    },
    guidesIndex: {
      title: 'Horeca-gidsen — GastroBuddy',
      description:
        'Praktische gidsen over openen en sluiten, inwerken, HACCP-achtige checks, kasafsluiting, mise en place en multi-locatie.',
    },
    notFound: {
      title: 'Pagina niet gevonden — GastroBuddy',
      description: 'Deze pagina bestaat niet. Ga terug naar de homepage van GastroBuddy.',
    },
  },
  nav: {
    home: 'Home',
    login: 'Inloggen',
    signup: 'Gratis aanmelden',
    language: 'Taal',
    primary: 'Hoofdnavigatie',
  },
  footer: {
    copyright: '© {year} GastroBuddy',
    terms: 'Algemene voorwaarden',
    privacy: 'Privacy',
    cookies: 'Cookies',
    contact: 'Contact',
    compare: 'Vergelijken',
    checklist: 'Gratis checklist',
    pricing: 'Prijzen',
    forVenues: 'Voor jouw zaak',
    guides: 'Gidsen',
    language: 'Taal',
    nav: 'Voettekst',
  },
  home: {
    heroTitle: 'Één app voor je vloer: checklists, kas, recepten en een AI-assistent',
    heroSubtitle:
      'Minder gedoe op de dienst. Maak lijsten en recepten via chat, beheer locaties in de browser, en laat de ringband staan.',
    ctaPrimary: 'Start mijn gratis maand',
    ctaPrimaryHint: 'Eerste maand gratis · Klaar in een paar minuten',
    trustLabel: 'Waarom ondernemers hier starten',
    trustFreeMonth: 'Eerste maand gratis',
    trustSetup: 'Klaar in een paar minuten',
    trustApps: 'iOS, Android en web',
    trustTeam: 'Nodig personeel uit wanneer jij wilt',
    stickyCtaLabel: 'Start gratis proefperiode',
    stickyCta: 'Start gratis maand',
    stickyCtaHint: 'Geen creditcard nodig om te kijken',
    compareLink: 'Vergelijk opties',
    checklistLink: 'Gratis open/sluit-checklist',
    forLink: 'Voor restaurants, hotels en meer',
    guidesLink: 'Horeca-gidsen',
    sectionReadyTitle: 'Klaar om het met je team te proberen?',
    sectionReadyBody:
      'Maak in een paar minuten een account en zet alleen de modules aan die je nodig hebt: takenlijsten, kas, recepten en meer.',
    ctaSecondary: 'Maak mijn gratis account',
    ctaSecondaryHint: 'Gratis proefperiode · Nodig personeel uit wanneer jij wilt',
    downloadTitle: 'Ook op iOS en Android',
    heroHomeAlt: 'GastroBuddy-app: startscherm met dagelijkse werkzaamheden',
    heroTasklistAlt: 'GastroBuddy-app: takenlijst voor checklists op de vloer',
    videoTitle: 'GastroBuddy productvideo',
    videoHeading: 'Zo ziet het eruit op de vloer',
    videoLede: 'Kort beeld van openen, sluiten en dagelijkse ops met GastroBuddy en je team.',
    outcomesTitle: 'Wat er verandert op de dienst',
    outcomesLede: 'Minder nachecken. Duidelijker wie wat doet. Sneller inwerken.',
    outcomes: {
      oneTitle: 'Alles op één plek',
      oneBody: 'Realtime voortgang per taak. Iedereen ziet wat klaar is en wat nog moet.',
      twoTitle: 'Duidelijk wie wat doet',
      twoBody:
        'Kwaliteit en verantwoordelijkheid blijven zichtbaar over diensten. Niet in de chat.',
      threeTitle: 'Sneller inwerken',
      threeBody: 'Stappenplannen van openen tot sluiten. Nieuw personeel draait sneller mee.',
    },
    modulesTitle: 'Modules die je aanzet wanneer jij wilt',
    modulesLede:
      'Begin met checklists. Voeg kas, recepten en de rest toe zodra jouw zaak dat nodig heeft.',
    modules: {
      aiTitle: 'AI-assistent',
      aiBody: 'Maak lijsten en recepten via chat, haal locaties op en stel rapporten op.',
      tasklistTitle: 'Takenlijsten',
      tasklistBody: 'Openen, sluiten en dagelijkse checklists met gedeelde voortgang.',
      cashTitle: 'Kasafsluiting',
      cashBody: 'Kasregistratie en dagafsluitingen, zonder spreadsheet-chaos.',
      recipesTitle: 'Recepten',
      recipesBody: 'Ingrediënten en recepten voor keuken en bar.',
      dashboardTitle: 'Webdashboard',
      dashboardBody: 'Beheer locaties, lijsten en recepten in de browser.',
      mepTitle: 'Mise en place',
      mepBody: 'Preplijsten die aansluiten op hoe jouw stations echt draaien.',
      facilityTitle: 'Facilitair',
      facilityBody: 'Schoonmaak, onderhoud en vloerlijsten die je team elke dag kan afvinken.',
      whiteboardTitle: 'Team-whiteboard',
      whiteboardBody: 'Gedeelde notities voor de vloer, zichtbaar voor het hele team.',
    },
  },
  onboard: {
    thankYouTitle: 'Bedankt voor je aanmelding',
    thankYouBodyBefore: 'Log in op het dashboard om je locatie af te ronden.',
    thankYouLink: 'Open GastroBuddy-dashboard',
  },
  forms: {
    signupTitle: 'Aanmelden',
    signupBullet1: 'Maak in drie stappen een account. Geen verplichtingen.',
    signupBullet2: 'Voeg takenlijsten en teamleden toe in de GastroBuddy Manager',
    signupBullet3: 'Je team kan meteen aan de slag met GastroBuddy',
    fullName: 'Volledige naam',
    email: 'E-mail',
    password: 'Wachtwoord',
    passwordTitle: 'Kies een wachtwoord',
    passwordLede: 'Gebruik minimaal 8 tekens. Je kunt het tonen tijdens het typen.',
    businessTitle: 'Bedrijfsgegevens',
    businessLede: 'Vertel over je zaak zodat we je locatie kunnen klaarzetten.',
    businessName: 'Bedrijfsnaam',
    address: 'Adres',
    city: 'Plaats',
    postalCode: 'Postcode',
    phone: 'Telefoonnummer',
    next: 'Volgende',
    back: 'Terug',
    createAccount: 'Account aanmaken',
    creatingAccount: 'Account aanmaken…',
    stepProgress: 'Stap {current} van {total}',
    checkoutClaimNote:
      'Je plan uit checkout wordt na aanmelden aan dit account gekoppeld. Geen extra betaling in de app.',
    passwordHint: 'Minimaal 8 tekens',
    showPassword: 'Toon',
    hidePassword: 'Verberg',
    googleContinue: 'Doorgaan met Google',
    googleContinueLoading: 'Google openen…',
    googleFailed: 'Google-aanmelden is niet gelukt. Probeer opnieuw of gebruik e-mail.',
    googleSessionExpired: 'Je Google-sessie is verlopen. Ga opnieuw door met Google.',
    orEmail: 'Of ga verder met e-mail',
    postalHint: 'Nederlands formaat, bijv. 1234 AB',
    phoneHint: 'Voeg indien nodig land- of netnummer toe',
    valNameRequired: 'Vul je volledige naam in',
    valEmailRequired: 'Vul je e-mailadres in',
    valEmailInvalid: 'Vul een geldig e-mailadres in',
    valPasswordMin: 'Wachtwoord moet minimaal 8 tekens zijn',
    valPasswordRequired: 'Kies een wachtwoord',
    valBusinessRequired: 'Vul je bedrijfsnaam in',
    valAddressRequired: 'Vul het straatadres in',
    valCityRequired: 'Vul de plaats in',
    valZipFormat: 'Gebruik formaat 1234 AB',
    valZipRequired: 'Vul de postcode in',
    valPhoneRequired: 'Vul een telefoonnummer in',
    valPhoneMin: 'Telefoonnummer moet minimaal 8 tekens zijn',
    requestFailed: 'We konden je account niet aanmaken. Controleer je gegevens en probeer opnieuw.',
    networkError: 'Verbinding mislukt. Controleer je netwerk en probeer opnieuw.',
  },
  notFound: {
    title: 'Pagina niet gevonden',
    backHome: 'Terug naar home',
  },
  terms: {
    title: 'Algemene voorwaarden',
    intro:
      'Deze algemene voorwaarden ("Voorwaarden") zijn van toepassing op je gebruik van GastroBuddy-software en gerelateerde diensten van ons ("GastroBuddy", "wij", "ons"). Door een account aan te maken of de dienst te gebruiken, ga je akkoord met deze Voorwaarden.',
    notice:
      'Dit is een algemene websitetekst. Laat je tekst beoordelen door je juridisch adviseur en pas aan voor jouw entiteit en rechtsgebied.',
    s1: '1. De dienst',
    s1Body:
      'GastroBuddy biedt tools voor horeca-operatie (o.a. checklists, kas, recepten, tijdregistratie en gerelateerde functies). Functies kunnen verschillen per plan, locatie en configuratie.',
    s2: '2. Accounts en geschiktheid',
    s2Body:
      'Je verstrekt juiste registratiegegevens en bewaart inloggegevens veilig. Je bent verantwoordelijk voor activiteit onder je account. Je moet bevoegd zijn je bedrijf te binden als je namens een organisatie registreert.',
    s3: '3. Aanvaardbaar gebruik',
    s3Body:
      'Je misbruikt de dienst niet, probeert geen ongeautoriseerde toegang, verstoort andere gebruikers niet en gebruikt GastroBuddy niet in strijd met de wet. We kunnen toegang opschorten of beëindigen bij overtreding of risico voor het platform.',
    s4: '4. Abonnementen en kosten',
    s4Body:
      'Betaalde plannen, proefperiodes en facturatie worden getoond bij aankoop of in je account. Tenzij anders vermeld, zijn kosten niet terugbetaalbaar behalve waar de wet dat vereist. We kunnen prijzen wijzigen met redelijke termijn.',
    s5: '5. Gegevens en privacy',
    s5Before: 'Onze verwerking van persoonsgegevens staat in ons',
    s5After:
      '. Je bent zelf verantwoordelijk voor naleving van wetten voor jouw bedrijf en personeelsgegevens.',
    s6: '6. Disclaimer en aansprakelijkheid',
    s6Body:
      'De dienst wordt geleverd "zoals ze is" voor zover de wet dat toestaat. We garanderen geen ononderbroken of foutloze werking. Onze totale aansprakelijkheid voor claims uit deze Voorwaarden of de dienst is beperkt tot wat de wet toestaat.',
    s7: '7. Wijzigingen',
    s7Body:
      'We kunnen deze Voorwaarden van tijd tot tijd bijwerken. Verder gebruik na wijzigingen betekent akkoord met de gewijzigde Voorwaarden, voor zover de wet dat toestaat.',
    s8: '8. Contact',
    s8Before: 'Vragen over deze Voorwaarden: zie onze',
    s8After: 'pagina.',
  },
  privacy: {
    title: 'Privacybeleid',
    intro:
      'Dit privacybeleid legt uit hoe GastroBuddy ("wij", "ons") persoonsgegevens verwerkt wanneer je onze website, het webdashboard en mobiele apps gebruikt.',
    notice:
      "Vervang deze tekst door een versie die beoordeeld is door je FG of juridisch adviseur, vooral bij EU/UK (AVG) of andere regio's.",
    h1: '1. Wie is verantwoordelijk?',
    p1Before:
      'De verwerkingsverantwoordelijke voor de dienst is de bedrijfsentiteit die GastroBuddy voor jouw contract levert. Voor vragen: contact op de',
    p1After: 'pagina.',
    h2: '2. Welke gegevens verwerken we',
    p2Before:
      'Afhankelijk van je gebruik kan dit onder meer zijn: account- en contactgegevens (bijv. naam, e-mail), organisatie- en locatie-informatie, gebruiks- en loggegevens, door jou ingevoerde inhoud (bijv. takenlijsten, recepten, operationele gegevens), en technische gegevens (bijv. apparaat, IP-adres, cookies — zie onze',
    p2After: ').',
    cookieLink: 'Cookie-informatie',
    h3: '3. Doelen en grondslagen',
    p3: 'We verwerken gegevens om de dienst te leveren en te verbeteren, gebruikers te authenticeren, abonnementen te factureren, met je te communiceren, veiligheid te waarborgen en wettelijke verplichtingen na te komen. Bij AVG gebruiken we o.a. overeenkomst, gerechtvaardigd belang, toestemming (waar nodig) en wettelijke verplichting.',
    h4: '4. Verwerkers en doorgifte',
    p4: 'We gebruiken infrastructuur en subprocessors (bijv. hosting, authenticatie, analytics) die gegevens verwerken volgens onze instructies. Gegevens kunnen in de EER en andere landen met passende waarborgen worden verwerkt.',
    h5: '5. Bewaartermijn',
    p5: 'We bewaren gegevens alleen zolang nodig voor bovenstaande doelen, inclusief juridische, fiscale en geschilvereisten, tenzij de wet langer vereist.',
    h6: '6. Jouw rechten',
    p6: 'Waar van toepassing heb je rechten op inzage, rectificatie, wissing, beperking, bezwaar, en gegevensoverdracht, en kun je een klacht indienen bij een toezichthouder. Neem contact op om rechten uit te oefenen.',
    h7: '7. Wijzigingen',
    p7: 'We kunnen dit beleid van tijd tot tijd bijwerken. We plaatsen de gewijzigde versie op deze pagina en, indien passend, informeren we je via de dienst.',
  },
  cookies: {
    title: 'Cookies & vergelijkbare technieken',
    intro:
      'Deze pagina beschrijft hoe we cookies en vergelijkbare technieken gebruiken op gastrobuddy.nl en gerelateerde sites.',
    h1: '1. Wat zijn cookies?',
    p1: 'Cookies zijn kleine bestanden op je apparaat. We gebruiken ook vergelijkbare technieken (bijv. local storage) waar nodig voor de dienst.',
    h2: '2. Hoe we ze gebruiken',
    essential:
      'Essentieel: nodig voor beveiliging, load balancing en kernfunctionaliteit van de site.',
    preferences: 'Voorkeuren: onthouden van keuzes zoals taal waar van toepassing.',
    analytics:
      'Analytics / marketing: we kunnen tools (bijv. Google Tag Manager) gebruiken voor inzicht in verkeer en campagnes, met toestemming waar nodig.',
    h3: '3. Cookies beheren',
    p3: 'Je kunt cookies beheren via je browserinstellingen. Het blokkeren van sommige cookies kan de functionaliteit beperken.',
    h4: '4. Meer informatie',
    p4Before: 'Persoonsgegevens met betrekking tot cookies vallen onder ons',
    p4After: '.',
  },
  contact: {
    title: 'Contact',
    intro: 'Vragen over GastroBuddy, je account of een samenwerking? We helpen je graag.',
    customers: 'Bestaande klanten',
    customersBody:
      'Log in op het webdashboard voor account- en locatiebeheer. Gebruik Inloggen in de header, of ga naar de manager-URL uit je onboarding.',
    legal: 'Juridisch & privacy',
    legalBefore:
      'Voor privacyverzoeken of juridische kennisgevingen: neem contact op via dezelfde kanalen en vermeld "Privacy" in het onderwerp. Zie ook ons',
    legalMid: 'en',
    legalAfter: '.',
  },
  pricing: {
    title: 'GastroBuddy prijzen',
    intro:
      'Kies een basisplan op teamgrootte, voeg modules per locatie toe, en ga door naar veilige checkout. Of start eerst een gratis proefperiode.',
    cancelled: 'Checkout is geannuleerd. Pas je plan hieronder aan wanneer je klaar bent.',
    tiersHeading: 'Organisatieplan',
    tiersHint: 'Teamlimieten gelden per locatie.',
    staffStarter: 'Tot 5 teamleden',
    staffPro: '6–20 teamleden',
    staffEnterprise: 'Onbeperkt teamleden',
    tiers: {
      starter: { name: 'Starter' },
      pro: { name: 'Pro' },
      enterprise: { name: 'Enterprise' },
    },
    modulesHeading: 'Locatiemodules',
    modulesHint: 'Prijzen per locatie / maand. Takenlijsten en recepten zitten in elk plan.',
    included: 'Inbegrepen: takenlijsten + recepten',
    modules: {
      modCash: 'Kassa',
      modTimesheet: 'Urenregistratie',
      modReservations: 'Reserveringen',
      modMep: 'Mise en place',
      modFacility: 'Facility',
    },
    summaryHeading: 'Je maandelijkse totaal',
    summaryNote: 'Add-ons gaan uit van één locatie. Extra locaties regel je na aanmelden.',
    total: 'Totaal',
    perMonth: '/mnd',
    perLocationMonth: '/loc/mnd',
    checkoutCta: 'Door naar checkout',
    checkoutLoading: 'Checkout openen…',
    trialCta: 'Liever gratis proefperiode',
    enterpriseContact: 'Liever overleg? Neem contact op',
    footnote:
      'Abonnementen worden via Stripe op het web gefactureerd. De app ontgrendelt na inloggen met een actief account. Prijzen exclusief btw waar van toepassing.',
    errors: {
      apiMissing:
        'Facturatie is hier niet geconfigureerd. Probeer later opnieuw of neem contact op.',
      checkoutFailed: 'Checkout starten mislukt. Controleer je verbinding en probeer opnieuw.',
      network: 'Netwerkfout. Controleer je verbinding en probeer opnieuw.',
    },
  },
  compare: {
    title: 'Hoe GastroBuddy zich verhoudt',
    intro:
      'Ondernemers beginnen vaak met papier, spreadsheets, WhatsApp of een kassa die nooit voor checklists is gemaakt. Hier een eerlijke categorievergelijking. Geen concurrentenlijst.',
    tableCaption: 'Vergelijking van papier, generieke tools en GastroBuddy voor horeca-operaties',
    colTopic: 'Behoefte',
    colPaper: 'Papier / ringband',
    colGeneric: 'Spreadsheets en chat',
    colGastro: 'GastroBuddy',
    rows: {
      progress: {
        topic: 'Live taakvoortgang',
        paper: 'Geen gedeelde status. Managers achtervolgen updates.',
        generic: 'Berichten verdwijnen. Lastig te zien wat klaar is.',
        gastro: 'Realtime voortgang per taak voor het hele team',
      },
      cash: {
        topic: 'Kas en dagafsluiting',
        paper: 'Apart schrift of kassablad',
        generic: 'Ad-hoc sheets. Historie raakt zoek.',
        gastro: 'Kasregistratie en dagafsluitingen op één plek',
      },
      recipes: {
        topic: 'Recepten en mise en place',
        paper: 'Gedrukte mappen raken verouderd',
        generic: 'Documenten verspreid over drives',
        gastro: 'Recepten en mise en place met keuken- en barcontext',
      },
      ai: {
        topic: 'Lijsten en recepten maken',
        paper: 'Met de hand herschrijven',
        generic: 'Sjablonen kopiëren',
        gastro: 'AI-assistent kan lijsten en recepten uit chat opstellen',
      },
      team: {
        topic: 'Nieuw personeel inwerken',
        paper: 'Meelopen en mondelinge kennis',
        generic: 'Lange chatthreads',
        gastro: 'Stappenplannen op telefoon of tablet',
      },
      paper: {
        topic: 'De ringband achterlaten',
        paper: 'Nog steeds meenemen',
        generic: 'Nog steeds “voor de zekerheid” printen',
        gastro: 'Hetzelfde account in apps en webdashboard',
      },
    },
    disclaimer:
      'Niet elke zaak heeft elke module nodig. Start met de gratis maand, zet aan wat je gebruikt, en nodig personeel uit wanneer jij wilt.',
    cta: 'Start mijn gratis maand',
    ctaHint: 'Eerste maand gratis · Klaar in een paar minuten',
    checklistLink: 'Liever iets printbaars? Pak de gratis open/sluit-checklist →',
  },
  checklist: {
    title: 'Gratis open/sluit-checklist',
    intro:
      'Een praktisch startpunt voor routines op de vloer. Pas hem aan je zaak aan. Draai dezelfde aanpak daarna in GastroBuddy, zodat iedereen de voortgang ziet.',
    openTitle: 'Openen',
    closeTitle: 'Sluiten',
    open: {
      o1: 'Openen, licht, muziek en klimaat naar wens',
      o2: 'Toiletten, vloeren en gastgerichte ruimtes checken',
      o3: 'Stations, ijs, garnish en to-go-voorraden bijvullen',
      o4: 'Kassas, wisselgeld en pinapparaten gereed melden',
      o5: 'Team briefen over reserveringen, 86’s en allergenen',
      o6: 'Koelkasttemperaturen en kritieke voedselveiligheid checken',
    },
    close: {
      c1: 'Stations opruimen, resetten en bijvullen voor de volgende dienst',
      c2: 'Eindafrekening kas, fooien en dagafsluiting',
      c3: 'Gastgebieden, toiletten en contactpunten schoonmaken',
      c4: 'Voorraad, koeling en drank veilig afsluiten',
      c5: 'Sluitchecklist-items van de dienst afronden',
      c6: 'Afsluiten, alarm, en notities voor de volgende open',
    },
    adaptNote:
      'Gebruik dit als voorbeeld. Jouw zaak heeft misschien HACCP-stappen, alleen-bar items of meerdere locaties. Daar is GastroBuddy voor gebouwd.',
    formTitle: 'Mail mij deze checklist',
    formIntro:
      'Optioneel: laat je zakelijke e-mail achter, dan sturen we de checklist naar je inbox. Geen spam.',
    formEmail: 'Zakelijke e-mail',
    formBusiness: 'Bedrijfsnaam (optioneel)',
    formSubmit: 'Stuur mij de checklist',
    formSubmitting: 'Versturen…',
    formError: 'Er ging iets mis. Probeer opnieuw, of start direct je gratis account.',
    formEmailRequired: 'Vul een zakelijke e-mail in, dan sturen we de checklist.',
    formEmailInvalid: 'Vul een geldig e-mailadres in (bijvoorbeeld naam@restaurant.nl).',
    formSuccessTitle: 'Bedankt. Check je inbox.',
    formSuccessBody: 'De checklist is onderweg. Je kunt ook nu je gratis maand starten.',
    formPrivacyBefore:
      'We gebruiken je gegevens alleen om deze checklist te mailen en relevante GastroBuddy-tips. Zie',
    formPrivacyAfter: ' voor details.',
    nextTitle: 'Klaar om dit met je team te draaien?',
    nextBody:
      'Zet dezelfde open- en sluitaanpak om in live takenlijsten. Met voortgang die iedereen ziet.',
    cta: 'Start mijn gratis maand',
    ctaHint: 'Gratis proefperiode · Nodig personeel uit wanneer jij wilt',
    compareLink: 'Bekijk hoe GastroBuddy zich verhoudt tot papier en spreadsheets →',
  },
  jsonLd: {
    orgDescription:
      'GastroBuddy helpt restaurants en bars bij dagelijkse operatie: checklists, kas, recepten, tijdregistratie en een AI-assistent voor eigenaren.',
    siteDescription:
      'Horeca-platform: takenlijsten, kas, mise en place, recepten voor keuken en bar, webdashboard en AI-assistent.',
  },
  verticals,
  guides,
} as const;

export default nl;



// WEBPACK FOOTER //
// ./src/i18n/messages/nl.ts